import { AppRole, ROLES } from "../types/roles";
import { AccountInfo } from "@azure/msal-browser";

const STORAGE_KEY = "demo.userRoles";

// Keyed by Azure AD user id (oid / localAccountId)
type RoleStore = Record<string, AppRole>;

export function resolveCurrentUserRole(account?: AccountInfo): AppRole {
  if (!account?.localAccountId) {
    return ROLES.VIEWER;
  }

  const store: RoleStore = JSON.parse(
    localStorage.getItem(STORAGE_KEY) || "{}"
  );

  return store[account.localAccountId] ?? ROLES.ADMIN; // admin default for demo
}

export function setUserRole(userId: string, role: AppRole) {
  const store: RoleStore = JSON.parse(
    localStorage.getItem(STORAGE_KEY) || "{}"
  );

  store[userId] = role;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}
